import SmsInbox from '@/modules/smsinbox/views/SmsInbox.vue';
import QuickGuide from "@/modules/smsinbox/views/ReceiveSmsQuickGuide.vue";

export const SmsInboxRoutes = [
    {
        path: '/inbox',
        component: SmsInbox,
    },
    {
        path: '/inbox/quickguide',
        component: QuickGuide,
    }
];
